"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Context_1 = __importDefault(require("../../Enums/Context"));
exports.default = {
    default: {
        text: 'Vous devez avoir une adresse pour une livraison à domicile.', buttons: [
            {
                label: 'Saisir mon adresse', route: {
                    name: "account-dlp-search-step1-".concat(Context_1.default.Basket, "-home"), params: {
                        type: "point-relais"
                    }
                },
            },
            {
                label: 'Annuler',
            }
        ],
    }
};
//# sourceMappingURL=ORDBASK030Handler.js.map